var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CElementCover',{attrs:{"opacity":0.75}},[_c('div',{staticClass:"text-dark p-3 text-center"},[_c('img',{attrs:{"src":_vm.imageName,"alt":"Spinner","height":_vm.size,"width":_vm.size}}),_c('h4',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }